import { flow, map, sum, getOr } from 'lodash/fp';

export default (allItems, prop, container) => flow(
  map(id => getOr(0, `${id}.${prop}`)(allItems)),
  sum,
)(container.items);
